
import {  Pricing } from '../../components';

function Services() {
  return (
    <>
      <Pricing />
      {/**
       * 
       <InfoSection {...homeObjOne} />
      

      <InfoSection {...homeObjThree} />
       */}
    </>
  );
}

export default Services;